module.exports = __webpack_public_path__ + "static/media/gold-ribbon.6b4b1d5d.svg";